var _circle, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1_3",
    "data-name": "Component 1 \u2013 3",
    viewBox: "0 0 53 53"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#623fda"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    y1: 11,
    x2: 9,
    transform: "translate(24 21)",
    fill: "none",
    stroke: "#f6f6f6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_142",
    "data-name": "Line 142",
    x1: 4,
    y1: 4,
    transform: "translate(20 28)",
    fill: "none",
    stroke: "#f6f6f6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })));
};
export default __webpack_public_path__ + "static/media/accept_button2.e3b368e8.svg";
export { SvgComponent as ReactComponent };